<xux-widget-boilerplate [field]="field">
  <div class="xux-input-currency-wrapper" [ngClass]="position">
    <span class="currency-sign">{{ currencySign }}</span>
    <xvi-input-currency
      [field]="field"
      [class]="inputClass"
      [required]="field.required"
      [placeholder]="field.placeholder"
      [control]="field?.control"
      [type]="field.type"
      [step]="field.multipleOf"
      [divisor]="field.widgetData?.divisor || 1"
      [min]="field.minimum"
      [max]="field.maximum"
      [hideArrows]="field.hideArrows"
      [currencySign]="currencySign"
      [precision]="precision"
      [notRoundInitValue]="notRoundInitValue"
      [disabled]="disabled"
      [defaultValueByClear]="defaultValueByClear"
      [autoPaddingZero]="autoPaddingZero"
      [stopPrecisionValidator]="stopPrecisionValidator"
      [numberMultipleOfValidator]="numberMultipleOfValidator"
    ></xvi-input-currency>
  </div>
</xux-widget-boilerplate>
